const contacts = [
  {
    id: 1,
    name: "Github",
    icon: require("../images/contacts/github.svg"),
    type: "social-media",
    url: "https://github.com/mirenguerra",
    user: "@mirenguerra",
  },
  {
    id: 2,
    name: "Twitter",
    icon: require("../images/contacts/twitter.svg"),
    type: "social-media",
    url: "https://twitter.com/Miren_GS",
    user: "@Miren_GS",
  },
  {
    id: 3,
    name: "Linkedin",
    icon: require("../images/contacts/linkedin.svg"),
    type: "social-media",
    url: "https://www.linkedin.com/in/mirenguerrasanz/",
    user: "mirenguerrasanz",
  },
  {
    id: 4,
    name: "Email",
    icon: require("../images/contacts/mail.svg"),
    type: "email",
    url: "mailto:miren.guerra.sanz@gmail.com",
    user: "miren.guerra.sanz@gmail.com",
  },
];

export default contacts;
